import { render } from "./BackgroundPage.vue?vue&type=template&id=5b427d1e"
import script from "./BackgroundPage.vue?vue&type=script&lang=js"
export * from "./BackgroundPage.vue?vue&type=script&lang=js"

import "./BackgroundPage.vue?vue&type=style&index=0&id=5b427d1e&lang=css"

import exportComponent from "C:\\Programowanie\\Projects\\last38minutes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__